import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { pathOr } from 'ramda';

import {
	VarChar,
	Label,
	Enum,
	Bool,
	DateField,
	DateTime,
	Text,
	Wysiwyg,
	Relate,
	Currency,
	Numeric,
	DynamicEnum,
	Url,
	FileUpload,
	RadioEnum,
	RadioSwitch,
	Parent,
	MultipleSelect,
	LineItem,
	Address,
	Email,
	DateSearch,
	Password,
	Reminders,
	CurrencySearch,
	ReminderTime,
	YearField

} from '../FormComponents';


const FormInput = (props) => {

	const [value, setValue] = useState(props.field.value || '');
	const { config } = useSelector((state) => state.config);

	const configurator = pathOr([], ['hideShowConf', 'appConfigurator', props.module], config);
	const {disabledAlways,hiddenAlways,...rest}= configurator;
	const innerHiddenAlways = Object.values(rest).find(o =>o.fieldsSel[0] ===props.field.name);

// if(innerHiddenAlways && props.initialValues[props.field.name]){
// 		const innerHiddenAlways2 = Object.values(innerHiddenAlways.condition).find(o =>o.field_value[0] ===props.initialValues[props.field.name])
	
// 		hiddenAlways.push(innerHiddenAlways2.hiddenField[0]);
// 	// if(innerHiddenAlways['condition']['field_value'].some(item =>item ===props.initialValues[props.field.name])){
// 	// 	console.log("configurator")
// 	// 	console.log(innerHiddenAlways, props.initialValues[props.field.name])
// 	// }
// 	console.log("innerHiddenAlways2", innerHiddenAlways2,hiddenAlways)
// }
	useEffect(() => setValue(props.value), [props.value]);

	const onValueChange = (value) => {
		//console.log("onValueChange", value);
		setValue(value);
		props.onChange(value);
	};

	
	// if((hiddenAlways && !hiddenAlways.find(o => o === props.field.name)) ){
	switch (props.field.type) {
		case 'bool':
			return <Bool {...props} onChange={(value) => onValueChange(value)} value={value} />;
		case 'currency':
			return(
				props.view === 'SearchLayout' ? <CurrencySearch {...props} onChange={(value) => onValueChange(value)} value={value} /> :
				<Currency {...props} onChange={(value) => onValueChange(value)} value={value} />
			); 
		case 'date':
			return (
				<DateField {...props} onChange={(value) => onValueChange(value)} value={value ? value : ""} />
			);
			case 'year':
			return (
				<YearField {...props} onChange={(value) => onValueChange(value)} value={value ? value : ""} />
			);
		case 'datetimecombo':
		case 'datetime':
			return (
				props.view === 'SearchLayout' ? <DateSearch {...props} onChange={(value) => onValueChange(value)} value={value ? value : ""} /> :
					<DateTime {...props} onChange={(value) => onValueChange(value)} value={value ? value : ""} />
			);
		// case 'datetimecombo':
		// 	return (
		// 		<DateTime {...props} onChange={(value) => onValueChange(value)} value={value ? value : ""} />
		// 	);
		case 'dynamicenum':
			return <DynamicEnum {...props} onChange={(value) => onValueChange(value)} value={value} />;
		case 'enum':	
			return <Enum {...props} onChange={(value) => onValueChange(value)} value={value} />;
		case "radioenum":
			return (
				<RadioEnum
					{...props}
					onChange={(value) => onValueChange(value)}
					value={value}
				/>
			);
			case "radioswitch":
			return (
				<RadioSwitch
					{...props}
					onChange={(value) => onValueChange(value)}
					value={value}
				/>
			);
		// case 'html':
		// 	return <Html {...props} onChange={(value) => onValueChange(value)} value={value ? value : ''} />;
		case 'file':
		case 'image':
			return <FileUpload {...props} onChange={(file) => onValueChange(file)} value={value} />;
		case 'decimal':
		case 'float':
		case 'int':
			return <Numeric {...props} onChange={(value) => onValueChange(value)} value={value ? value : ''} />;
		case "multienum":
			return (
				<MultipleSelect
					{...props}
					onChange={(value) => onValueChange(value)}
					value={value ? value : []}
				/>
			);
		case 'parent':
			return <Parent {...props} onChange={(value) => onValueChange(value)} value={value} />;

		// case 'phone':
		// 	return <Phone {...props} onChange={(value) => onValueChange(value)} value={value ? value : ''} />;
		// case 'radioenum':
		// 	return <Radio {...props} onChange={(value) => onValueChange(value)} value={value ? value : ''} />;
		case 'assigned_user_name':
		case 'relate':
			return (
				<Relate
					{...props}
					onChange={(value) => onValueChange(value)}
					value={value ? value : { value: '', id: '' }}
				/>
			);
		case 'text':
			return <Text {...props} onChange={(value) => onValueChange(value)} value={value ? value : ''} />;
		case 'iframe':
		case 'url':
			return <Url {...props} onChange={(value) => onValueChange(value)} value={value ? value : ''} />;
		case 'wysiwyg':
			return <Wysiwyg {...props} onChange={(value) => onValueChange(value)} value={value ? value : ''} />;
		case 'line_item':
			return <LineItem {...props} onChange={(value) => onValueChange(value)} value={value ? value : ''} />;
		case 'address':
			return <Address {...props} onChange={(value) => onValueChange(value)} value={value ? value : ''} />;
		case 'email':
			return props.view==='SearchLayout'?
			<VarChar {...props} onChange={(value) => onValueChange(value)} value={value ? value : ''} />:
			<Email {...props} onChange={(value) => onValueChange(value)} value={value ? value : ''} />;
		case 'password':
			return props.field.name !== 'user_hash' ? <Password {...props} onChange={(value) => onValueChange(value)} value={value ? value : ''} /> : null;
		case 'label':
				return <label {...props} onChange={(value) => onValueChange(value)} value={value ? value : ''} />	
		default:
			switch (props.field.name) {
				case 'email1':
					return <Email {...props} onChange={(value) => onValueChange(value)} value={value ? value : ''} />;
				case 'reminders':
				 	return <Reminders {...props} onChange={(value) => onValueChange(value)}  value={value ? value : ''} />;
				case 'reminder_time':
				 	return <ReminderTime {...props} onChange={(value) => onValueChange(value)} value={value ? value : ''} />;
				default:
					return <VarChar {...props} onChange={(value) => onValueChange(value)} value={value ? value : ''} />;
			}
			// return <VarChar {...props} onChange={(value) => onValueChange(value)} value={value ? value : ''} />;
	}
// }else{
// 	return null;
// }
};

export default FormInput;
